import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'
import './spinner.css'

export default function Spinner(props) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.show}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
